const pendingLogins = new WeakSet();

function loginCard(element) {
    return element?.closest?.('[data-email-authentication]');
}

function showLoginError(card, message) {
    const summary = card.querySelector('[data-validate-error]');
    summary.textContent = message;
    summary.classList.add('oc-visible');
    card.querySelector('[data-login-recovery]').hidden = false;
}

function finishLoginRequest(card) {
    pendingLogins.delete(card);
    card.removeAttribute('aria-busy');
    card.querySelector('[data-login-progress]').hidden = true;
    card.querySelectorAll('button').forEach((button) => button.disabled = false);
}

// Keep a missing AJAX framework from falling back to a native form submission.
document.addEventListener('submit', function (event) {
    const card = loginCard(event.target);
    if (!card || window.oc?.request) return;

    event.preventDefault();
    showLoginError(card, 'The sign-in page could not finish loading. Please reload it and try again.');
}, true);

document.addEventListener('ajax:setup', function (event) {
    const card = loginCard(event.detail.context.el);
    if (card && pendingLogins.has(card)) {
        event.preventDefault();
    }
});

document.addEventListener('ajax:promise', function (event) {
    const card = loginCard(event.target);
    if (!card) return;

    pendingLogins.add(card);
    card.setAttribute('aria-busy', 'true');
    card.querySelector('[data-validate-error]').classList.remove('oc-visible');
    card.querySelector('[data-login-recovery]').hidden = true;
    card.querySelector('[data-login-progress]').hidden = false;
    card.querySelectorAll('button').forEach((button) => button.disabled = true);
});

document.addEventListener('ajax:request-error', function (event) {
    const card = loginCard(event.target);
    if (!card) return;

    const { responseCode, message } = event.detail;
    // October renders validation errors in the form's persistent summary.
    if (responseCode === 406 && message?.X_OCTOBER_ERROR_FIELDS) return;

    event.preventDefault();

    let error = 'Sign-in could not be completed. Please try again. If this continues, contact support.';
    if (responseCode === 419) {
        error = 'Your sign-in session has expired. Please reload this page and enter your details again.';
    } else if (responseCode === 429) {
        error = 'Too many requests. Please wait before trying again.';
    } else if (responseCode <= 0) {
        error = 'We could not connect to the server. Please check your connection and try again.';
    }

    showLoginError(card, error);
});

document.addEventListener('ajax:always', function (event) {
    const card = loginCard(event.target);
    if (card) finishLoginRequest(card);
});

window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('[data-email-authentication]').forEach(finishLoginRequest);
});
